import {TurnState} from '@colonist/game-states'
import {useGameStore} from '../GameStoreContext.ts'
import {useIsReplay} from './useIsReplay.ts'

export const useIsGameEnded = () => {
    const isReplay = useIsReplay()
    if(isReplay) return true

    const turnState = useGameStore((state) => state.gameState.currentState.turnState)
    return turnState === TurnState.GameEnd
}
